function getCookie(name) {
  const cookie = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return cookie && cookie[2];
}

function setCookie(name, value, days = 0, hours = 0) {
  const date = new Date();
  if (days || hours) {
    date.setTime(
      date.getTime() + hours * 60 * 60 * 1000 + 24 * 60 * 60 * 1000 * days
    );
    document.cookie =
      name + "=" + value + ";path=/;expires=" + date.toGMTString();
  } else {
    document.cookie = name + "=" + value + ";path=/";
  }
}
export function deleteCookie(name) {
  setCookie(name, "", -1);
}

export function deleteAllCookie() {
  document.cookie.split(";").forEach(function (c) {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
  deleteCookie("prevStateValues");
  deleteCookie("rta");
}

function kickUser() {
  window.location.href = `/`;
  deleteAllCookie();
  localStorage.removeItem("user_roles");
}

export { getCookie, setCookie, kickUser };
